import { Image, PasswordInput, ScrollArea, Tabs } from "@mantine/core";

import "./Login.scss";

import ValidateOTP from "../ValidateOTP/ValidateOTP";
import { EButton, EModal, ETextInput } from "../../../../libs/ui";
import AffiliateOnboardRequest from "../../Components/AffiliateOnboard/AffiliateOnboardRequest";

import useAuthentication from "../../Hooks/useAuthentication";

export default function Login() {

  const {
    navigate,
    activeStep,
    setActiveStep,

    activeTab,
    setActiveTab,
    loginParams,
    isLoggingIn,
    handleLoginPayloadChange,

    otp,
    setOTP,
    isManagingOTP,
    handleCancelOTPVerification,
    sendOTP,
    verifyOTP,

    showOnboardAgentModal,
    openOnboardAgentModal,
    closeOnboardAgentModal,
    removeQueryParam
  } = useAuthentication();

  return (
    <>
      <div className="page-login">
        <div className="background"></div>
        <div className="body">
          <div className="inner">
            <div className="h-full w-full flex justify-center items-center gap-3">
              <img
                className="h-32 w-auto rounded-lg"
                src={require("../../../../assets/logos/travelyatra.jpeg")}
                alt="Paul Merchants Logo"
              />
              {/* <Image
                w={60}
                h={60}
                radius="md"
                className=" shadow-blue-300 shadow"
                src={require("../../../../assets/image/PMLLogo.png")}
                alt="PLM_logo"
              /> */}
              {/* <p className="text-xl font-semibold">PML Travel Admin</p> */}
            </div>

            <div className="w-full px-6">
              {
                activeStep === 1
                  ?
                  <>
                    <Tabs
                      variant="default"
                      className="bg-slate-50 rounded"
                      value={activeTab}
                      onChange={(value: any) => setActiveTab(value ?? "admin")}
                    >
                      <Tabs.List grow>
                        <Tabs.Tab value="admin">Admin</Tabs.Tab>
                        <Tabs.Tab value="agent">Agent</Tabs.Tab>
                      </Tabs.List>
                    </Tabs>

                    <div className="flex flex-col gap-3 border-t-0 mt-5">
                      <div>
                        <h3 className="capitalize"> {activeTab} Sign in</h3>
                        <p className="text-sm opacity-50">
                          Please enter your{" "}
                          <span className="font-semibold opacity-90 ">{activeTab === "admin" ? "admin" : "agent"}</span>{" "}
                          credentials below to login
                        </p>
                      </div>

                      <form
                        className="signin-form "
                        onSubmit={(e) => {
                          e.preventDefault();
                        }}
                      >
                        <ETextInput
                          required
                          size="md"
                          variant="unstyled"
                          placeholder={"Enter Username"}
                          className="border-b px-2"
                          value={loginParams.userName}
                          onChange={(e) => {
                            const { value } = e.target;
                            handleLoginPayloadChange("userName", value);
                          }}
                        />

                        <PasswordInput
                          required
                          size="md"
                          variant="unstyled"
                          className="border-b px-2"
                          placeholder={"Enter Password (########)"}
                          value={loginParams.password}
                          onChange={(e) => {
                            const { value } = e.target;
                            handleLoginPayloadChange("password", value);
                          }}
                        />

                        <EButton
                          fullWidth
                          type="submit"
                          size="md"
                          className="btn-blue mt-5"
                          loading={isManagingOTP}
                          onClick={() => {
                            sendOTP();
                            // handleUserLogin();
                          }}
                        >
                          {"Sign in"}
                        </EButton>
                      </form>
                    </div>

                    <p className="text-center mt-5 text-sm">
                      Forgot password? {" "}
                      <span
                        className="text-blue-600 hover:underline hover:cursor-pointer"
                        onClick={() => navigate("/user/forgot-password")}
                      >Reset here</span>
                    </p>

                    <p className="text-center mt-5 text-sm">
                      Want to become an agent? {" "}
                      <span
                        className="font-semibold text-green-600 hover:underline hover:cursor-pointer"
                        onClick={openOnboardAgentModal}
                      >Request here</span>
                    </p>
                  </>
                  :
                  <>
                    <ValidateOTP
                      setActiveStep={setActiveStep}
                      otp={otp}
                      setOTP={setOTP}
                      isManagingOTP={isManagingOTP}
                      isLoggingIn={isLoggingIn}
                      handleCancelOTPVerification={handleCancelOTPVerification}
                      verifyOTP={verifyOTP}
                    />
                  </>
              }
            </div>
            <div></div>
          </div>
        </div>
      </div>

      <EModal
        size={"80%"}
        closeOnClickOutside={false}
        closeOnEscape={false}
        scrollAreaComponent={ScrollArea.Autosize}
        title="Request to become an affiliate"
        opened={showOnboardAgentModal}
        onClose={() => {
          closeOnboardAgentModal();
          removeQueryParam("affiliateRegistration");
        }}
      >
        <AffiliateOnboardRequest
          onSave={() => closeOnboardAgentModal()}
          onCancel={() => {
            closeOnboardAgentModal();
            removeQueryParam("affiliateRegistration");
          }}
        />
      </EModal>
    </>
  );
}